export default "__VITE_ASSET__EaxuLFxc__"